import { render, staticRenderFns } from "./LoginModals.vue?vue&type=template&id=1b53b3ef"
import script from "./LoginModals.vue?vue&type=script&lang=ts"
export * from "./LoginModals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports